import { tableSchema } from '@nozbe/watermelondb'

export default tableSchema({
  name: 'contents',
  columns: [
    { name: 'algolia_id', type: 'number', isIndexed: true },
    { name: 'title', type: 'string' },
    { name: 'description', type: 'string' },
    { name: 'photo', type: 'string' },
    { name: 'lyrics', type: 'string' },
    { name: 'content_type', type: 'string' },
    { name: 'popularity_score', type: 'number' },
    { name: 'artist', type: 'string' },
    { name: 'other_artists', type: 'string' },
    { name: 'length_in_seconds', type: 'number' },
    { name: 'content_collection', type: 'string' },
    { name: 'languages', type: 'string' },
    { name: 'tags', type: 'string' },
    { name: 'flags', type: 'string' },
    { name: 'categories', type: 'string' },
    { name: 'collection_number', type: 'number' },
    { name: 'upload_date', type: 'number' },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
  ],
})
